"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaWidget = void 0;
var React = __importStar(require("react"));
var react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
var styled_components_1 = __importDefault(require("styled-components"));
var CenteredReCaptcha = styled_components_1.default(react_google_recaptcha_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 12px;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-bottom: 12px;\n"])));
var CaptchaWidget = (function (_super) {
    __extends(CaptchaWidget, _super);
    function CaptchaWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function () {
            var recaptchaValue = _this.recaptchaRef.current.getValue();
            _this.props.onChange(recaptchaValue);
        };
        _this.recaptchaRef = React.createRef();
        return _this;
    }
    CaptchaWidget.prototype.componentDidMount = function () {
        if (!window.RECAPTCHA_V2_API_KEY) {
            this.props.onChange('dummy');
        }
    };
    CaptchaWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.value !== this.props.value && !Boolean(this.props.value)) {
            this.recaptchaRef.current.reset();
        }
    };
    CaptchaWidget.prototype.componentDidCatch = function (error) {
        console.error(error, 'The reCaptcha api key is invalid.');
    };
    CaptchaWidget.prototype.render = function () {
        var captchaKey = window.RECAPTCHA_V2_API_KEY;
        if (!captchaKey) {
            return null;
        }
        return (React.createElement(CenteredReCaptcha, { ref: this.recaptchaRef, onChange: this.onChange, sitekey: captchaKey }));
    };
    return CaptchaWidget;
}(React.Component));
exports.CaptchaWidget = CaptchaWidget;
var templateObject_1;
